import { NotFoundPage } from "@/ui";
import { Routes, Route, Navigate } from "react-router-dom";
import { NavigationProvider } from "@/utils/navigation";
import { useFlags } from "@/utils/flagsmith";
import { AdminLayout } from "./AdminLayout";
import { CompaniesLayout } from "./sections/companies/CompaniesLayout";
import InvestmentMemoPage from "./sections/companies/InvestmentMemo/InvestmentMemo.page";
import { DealsLayout } from "./sections/deals/DealsLayout";
import { OpportunityPage } from "./sections/companies/opportunities/Opportunity.page";
import LabelingUI from "./sections/companies/LabelingUI/LabelingUI.page";
import UploadsPage from "./sections/companies/Uploads/Uploads.page";
import MetricsPage from "./sections/companies/MetricsLab/metrics.page";
import ConnectorsPage from "./sections/companies/Connectors/Connectors.page";
// import CompanyProfilePage from "./sections/deals/CompanyProfile/CompanyProfilePage";
// import DealDetailPage from "./sections/deals/DealDetail/DealDetailPage";
// import { CreditBoxesPage } from "./sections/creditBoxes/CreditBoxesPage";

const EmptyPage = ({ text = "This page" }: { text?: string }) => (
    <div>{`${text} is not yet available in beta`}</div>
);

function AdminBetaApp() {
    const flags = useFlags();

    return (
        <NavigationProvider showLogout>
            <Routes>
                <Route path={`/beta`} element={<AdminLayout />}>
                    <Route
                        path="/beta"
                        index
                        element={<Navigate to="/beta/companies" />}
                    />
                    <Route
                        path={`/beta/companies`}
                        element={<CompaniesLayout />}
                    >
                        <Route path="/beta/companies" element={<EmptyPage />} />
                        <Route
                            path="/beta/companies/:companyId"
                            element={<EmptyPage text="Company Overview" />}
                        />
                        <Route
                            path="/beta/companies/:companyId/investment-memo"
                            element={<InvestmentMemoPage />}
                        />
                        <Route
                            path={`/beta/companies/:companyId/opportunities`}
                            element={<OpportunityPage />}
                        />
                        <Route
                            path={`/beta/companies/:companyId/opportunities/:opportunityId`}
                            element={<OpportunityPage />}
                        />
                        <Route
                            path={`/beta/companies/:companyId/labeling`}
                            element={<LabelingUI />}
                        />
                        <Route
                            path={`/beta/companies/:companyId/labeling/files/:fileId`}
                            element={<LabelingUI />}
                        />
                        <Route
                            path={`/beta/companies/:companyId/labeling/files/:fileId/drafts/:draftId`}
                            element={<LabelingUI />}
                        />
                        <Route
                            path={`/beta/companies/:companyId/uploads`}
                            element={<UploadsPage />}
                        />
                        <Route
                            path={`/beta/companies/:companyId/metrics`}
                            element={<MetricsPage />}
                        />
                        <Route
                            path={`/beta/companies/:companyId/connectors`}
                            element={<ConnectorsPage />}
                        />
                    </Route>
                    <Route path={`/beta/deals`} element={<DealsLayout />}>
                        <Route
                            path="/beta/deals"
                            element={<EmptyPage text="Deals" />}
                        />
                        <Route
                            path="/beta/deals/:dealId"
                            element={<EmptyPage text="Deal Detail" />}
                        />
                        <Route
                            path="/beta/deals/:dealId/company-profile"
                            element={<EmptyPage text="Company Profile" />}
                        />
                    </Route>

                    {flags.enabled("enable-credit-boxes") && (
                        <Route
                            path="/beta/credit-boxes"
                            element={<EmptyPage text="Credit Boxes" />}
                        />
                    )}
                </Route>
                <Route path="/beta/*" element={<NotFoundPage />} />
            </Routes>
        </NavigationProvider>
    );
}

export default AdminBetaApp;
